import { render, staticRenderFns } from "./Needs.vue?vue&type=template&id=331a802e&scoped=true&"
import script from "./Needs.vue?vue&type=script&setup=true&lang=js&"
export * from "./Needs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a802e",
  null
  
)

export default component.exports